import { useQuery } from "@grandvisionhq/graphql";
import { toPreferredStore } from "../../../mappers/Profile/mappers/profile.js";
import GET_PREFERRED_STORE_ID from "../../../operations/queries/Profile/operations/queries/get-preferred-store-id.js";
const usePreferredStore = () => {
  const { data, loading, error, refetch } = useQuery(GET_PREFERRED_STORE_ID);
  return {
    data: data?.me?.preferredStore ? toPreferredStore(data.me.preferredStore) : null,
    loading,
    error,
    refetch
  };
};
export {
  usePreferredStore
};
//# sourceMappingURL=use-preferred-store.js.map
